import React from 'react'
import { Link } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const Home = () => {
  return (
    <>
      {/* <!-- Start Hero Section --> */}
      <div class="hero">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-5">
              <div class="intro-excerpt">
                <h1>Where Better Sleep Begins.</h1>
                <p class="mb-4">Welcome to SpringUp Mattress — your trusted destination for premium mattresses and pillows designed to give you the sleep you deserve. We’re here to make buying a mattress or pillow online simple, affordable, and stress-free..</p>
                <p><Link to="/shopping" class="btn btn-secondary me-2">Shop Now</Link><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                  <i className="fa-solid fa-phone"></i> &nbsp; Call Us
                </a></p>
              </div>
            </div>

            <div className="col-lg-7">
              <div style={{ height: "350px", width: "100%" }}>
                <Carousel
                  className="custom-carousel"
                  autoPlay
                  infiniteLoop
                  showThumbs={false}
                  showStatus={false}
                  showIndicators={false}
                  showArrows={false}
                  dynamicHeight={false}
                >
                  <div>
                    <img
                      src="/images/Carosel.png"
                      alt="Slide 2"
                      style={{ height: "350px", width: "100%" }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/su_roundcornerB.jpg"
                      alt="Slide 1"
                      style={{ height: "350px", width: "100%" }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/su_BONANZA.jpg"
                      alt="Slide 2"
                      style={{ height: "350px", width: "100%" }}
                    />
                  </div>
                </Carousel>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* <!-- End Hero Section --> */}

      {/* <!-- Start Product Section --> */}
      <div class="product-section">
        <div class="container">
          <div class="row">

            {/* <!-- Start Column 1 --> */}
            <div class="col-md-12 col-lg-5 mb-5 mb-lg-0">
              <h2 class="mb-4 section-title" style={{ fontFamily: "postmans-serif" }}>Transform Your Bedroom Into a Modern Sleep Haven</h2>
              <p class="mb-4">At SpringUp Mattress, we believe that great sleep starts with great design. That’s why we craft our mattresses and pillows not just for unmatched comfort, but also to complement modern living spaces. Our minimal yet luxurious sleep solutions bring harmony to your bedroom, combining aesthetics with science-backed sleep support. Whether you're furnishing a new home or upgrading your current sleep setup, our clean designs and premium materials make it easier than ever to enjoy a restful, stylish sleep environment.</p>
              <p><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-phone"></i> &nbsp; Call Us
              </a></p>
            </div>
            {/* <!-- End Column 1 --> */}

            {/* <!-- Start Column 2 --> */}
            <div class="col-12 col-md-6 col-lg-6 mb-5 mb-md-0">
              {/* <Link class="product-item" to="cart.html"> */}
              <img src="images/su_roundcornerD.jpg" class="img-fluid product-thumbnail" style={{ height: "400px", width: "1450px" }} />
              {/* <h3 class="product-title">All Type Mattress</h3>

                <span class="icon-cross">
                  <img src="images/cross.svg" class="img-fluid" />
                </span>
              </Link> */}
            </div>
            {/* <!-- End Column 2 --> */}

          </div>
        </div>
      </div>
      {/* <!-- End Product Section --> */}

      {/* <!-- Start Why Choose Us Section --> */}
      <div class="why-choose-section">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-6">
              <h2 class="mb-4 section-title" style={{ fontFamily: "postmans-serif" }}>Why Choose SpringUp: Comfort, Convenience & Confidence</h2>

              <p class="mb-4">Shopping with SpringUp Mattress means you’re choosing a brand that prioritizes your sleep and satisfaction. We offer fast shipping, an effortless online shopping experience, 24/7 customer support, and hassle-free returns — all designed to make your journey smooth and worry-free. Every product we make — from orthopedic mattresses to plush, breathable pillows — is built with precision and care to give your body the rest it deserves. With SpringUp, you don’t just buy sleep products — you invest in better sleep, everyday comfort, and modern living.</p>
              <p>With thousands of satisfied customers across the country, SpringUp Mattress has become a trusted name in the bedding industry — where innovation meets comfort, and every night feels like a dream.</p>
              <p><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-phone"></i> &nbsp; Call Us
              </a></p>
            </div>

            <div class="col-lg-5">
              <div class="img-wrap">
                <img src="images/su_roundcornerc.jpg" alt="Image" class="img-fluid" />
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* <!-- End Why Choose Us Section --> */}

      {/* <!-- Start We Help Section --> */}
      <div class="we-help-section">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-7 mb-5 mb-lg-0">
              <div class="imgs-grid">
                <div class="grid grid-1"><img src="/images/mattress7.webp" alt="Untree.co" /></div>
                <div class="grid grid-2"><img src="images/spring4.jpg" alt="Untree.co" /></div>
                <div class="grid grid-3"><img src="/images/banner1.jpg" alt="Untree.co" /></div>
              </div>
            </div>
            <div class="col-lg-5 ps-lg-5">
              <h2 class="section-title mb-4">We Help You Make Modern Interior Design</h2>
              <p>At SpringUp Mattress, we blend comfort with contemporary design. Our premium mattresses and pillows are thoughtfully crafted to complement modern interiors while delivering unmatched support and style — giving your bedroom the upgrade it deserves.</p>

              <ul class="list-unstyled custom-list my-4">
                <li><strong>Minimal & Modern Designs –</strong> Perfect fit for today's interiors.</li>
                <li><strong>Comfort-Centric Products –</strong> Designed with your sleep in mind.</li>
                <li><strong>Premium Materials – </strong> Long-lasting quality you can feel.</li>
                <li><strong>Smart Sleep Solutions –</strong> Style meets restful support.</li>
              </ul>
              <p><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-phone"></i> &nbsp; Call Us
              </a></p>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End We Help Section --> */}

      {/* <!-- Start Popular Product --> */}
      {/* <div class="popular-product">
        <div class="container">
          <div class="row">

            <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
              <div class="product-item-sm d-flex">
                <div class="thumbnail">
                  <img src="images/product-1.png" alt="Image" class="img-fluid" />
                </div>
                <div class="pt-3">
                  <h3>Nordic Chair</h3>
                  <p>Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio </p>
                  <p><Link to="#">Read More</Link></p>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
              <div class="product-item-sm d-flex">
                <div class="thumbnail">
                  <img src="images/product-2.png" alt="Image" class="img-fluid" />
                </div>
                <div class="pt-3">
                  <h3>Kruzo Aero Chair</h3>
                  <p>Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio </p>
                  <p><Link to="#">Read More</Link></p>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
              <div class="product-item-sm d-flex">
                <div class="thumbnail">
                  <img src="images/product-3.png" alt="Image" class="img-fluid" />
                </div>
                <div class="pt-3">
                  <h3>Ergonomic Chair</h3>
                  <p>Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio </p>
                  <p><Link to="#">Read More</Link></p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div> */}
      {/* <!-- End Popular Product --> */}

      {/* <!-- Start Blog Section --> */}
      {/* <div class="blog-section">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <h2 class="section-title">Recent Blog</h2>
            </div>
            <div class="col-md-6 text-start text-md-end">
              <Link to="#" class="more">View All Posts</Link>
            </div>
          </div>

          <div class="row">

            <div class="col-12 col-sm-6 col-md-4 mb-4 mb-md-0">
              <div class="post-entry">
                <Link to="#" class="post-thumbnail"><img src="images/post-1.jpg" alt="Image" class="img-fluid" /></Link>
                <div class="post-content-entry">
                  <h3><Link to="#">First Time Home Owner Ideas</Link></h3>
                  <div class="meta">
                    <span>by <Link to="#">Kristin Watson</Link></span> <span>on <Link to="#">Dec 19, 2021</Link></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4 mb-4 mb-md-0">
              <div class="post-entry">
                <Link to="#" class="post-thumbnail"><img src="images/post-2.jpg" alt="Image" class="img-fluid" /></Link>
                <div class="post-content-entry">
                  <h3><Link to="#">How To Keep Your Furniture Clean</Link></h3>
                  <div class="meta">
                    <span>by <Link to="#">Robert Fox</Link></span> <span>on <Link to="#">Dec 15, 2021</Link></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4 mb-4 mb-md-0">
              <div class="post-entry">
                <Link to="#" class="post-thumbnail"><img src="images/post-3.jpg" alt="Image" class="img-fluid" /></Link>
                <div class="post-content-entry">
                  <h3><Link to="#">Small Space Furniture Apartment Ideas</Link></h3>
                  <div class="meta">
                    <span>by <Link to="#">Kristin Watson</Link></span> <span>on <Link to="#">Dec 12, 2021</Link></span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div> */}
      {/* <!-- End Blog Section -->	 */}
    </>
  )
}

export default Home;